import clsx from 'clsx';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  useForwardAccumulatorSelector,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { isNotDefined } from '@/components/sg-design-system/utils/index.ts';
import {
  getForwardAccumulatorMarketData,
  selectForwardAccumulatorCurrencyData,
  selectForwardAccumulatorProperty,
} from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

const Delta = () => {
  const { formatNumber } = useIntl();
  const tileId = useForwardAccumulatorTileId();
  const { notionalCurrencyIndex, currency } = useAppSelector((state) =>
    selectForwardAccumulatorCurrencyData(state, tileId),
  );
  const marketData = useForwardAccumulatorSelector((accumulator) => getForwardAccumulatorMarketData(accumulator));
  const hedgeType = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'hedgeType'));

  const isExpired = useForwardAccumulatorSelector((accumulator) => accumulator.properties.rfs.status === 'EXPIRED');

  if (isNotDefined(notionalCurrencyIndex)) {
    return null;
  }

  const delta = marketData?.delta?.[notionalCurrencyIndex - 1];

  return (
    <div className={clsx('form-group form-group-sm d-flex my-1 no-gutters', { expired: isExpired })}>
      <div className="pe-1 col-form-label col-form-label-sm col-4 text-nowrap text-end" style={{ width: '30%' }}>
        <FormattedMessage id="accumulator.fields.greeks.delta" values={{ hedgeType }} />
      </div>
      {delta && (
        <span className="col-7 fs-6" data-e2e="delta">
          {formatNumber(delta, { maximumFractionDigits: 0, minimumFractionDigits: 0 })} {currency}
        </span>
      )}
    </div>
  );
};

export default Delta;
